import React, { useEffect } from 'react'
import ReactQuill from 'react-quill-new';
  
import 'react-quill-new/dist/quill.snow.css';export default function ConfigPrice({ block, updateBlock }) {

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
             
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
            ['clean'],
        ],
    };

    const formats = [
        'header', 'font', 'bold', 'italic', 'underline', 'strike',
        'color', 'background', 'align', 'list',
        'link',  
    ];

    const descriptionPrice = block.descriptionPrice || 'Produto Mágico <br /> 50% de desconto <br /> <strong>R$97,90</strong>';
    const textUp = block.textUp || 'Apenas';
    const price = block.price || 'R$ 49,90';
    const textDown = block.textDown || 'ou 6x de R$9,36';
    const bgColor = block.bgColor || 'green';
    

    

  return (<div className="flex flex-col gap-2">

                <div className="flex flex-col gap-2">
                    <label className="block font-semibold mb-2 w-full">Descrição</label>
                    <ReactQuill theme="snow"
                    className="w-full p-2 bg-gray-100 rounded w-full h-full"
                    modules={modules}
                    formats={formats}
                    preserveWhitespace={true}
                    value={descriptionPrice}
                    onChange={(e) => updateBlock(block.id, 'descriptionPrice', e)} />

                </div>
                <div className="flex flex-col gap-2">
                    <label className="block font-semibold mb-2 w-full">Texto acima</label>
                    <input className="w-full p-2 bg-gray-100 rounded w-full h-full" type="text" value={textUp} onChange={(e) => updateBlock(block.id, 'textUp', e.target.value)} />
                </div>
                <div className="flex flex-col gap-2">
                    <label className="block font-semibold mb-2 w-full">Preço</label>
                    <input className="w-full p-2 bg-gray-100 rounded w-full h-full" type="text" value={price} onChange={(e) => updateBlock(block.id, 'price', e.target.value)} />
                </div>
                <div className="flex flex-col gap-2">
                    <label className="block font-semibold mb-2 w-full">Texto abaixo</label>
                    <input className="w-full p-2 bg-gray-100 rounded w-full h-full" type="text" value={textDown} onChange={(e) => updateBlock(block.id, 'textDown', e.target.value)} />
                </div>
                <div className="flex flex-col gap-2">
                    <label className="block font-semibold mb-2 w-full">Cor </label>
                        <select className="w-full p-2 bg-gray-100 rounded w-full h-full" value={bgColor} onChange={(e) => updateBlock(block.id, 'bgColor', e.target.value)}>
                        <option value="theme">Tema</option>
                        <option value="green">Verde</option>
                        <option value="blue">Azul</option>
                        <option value="yellow">Amarelo</option>
                        <option value="red">Vermelho</option>

                    </select>
                </div>
    </div>
  )
}